// Imports for external libraries go here.
import { useEffect, useState } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { useSession } from '@marriott/mi-headless-utils';
import { EVENT_NAME } from '../../modules/utils/constants';
import { pageViewACDLkeyGenerator } from '../../modules/utils';
import { useCurrentUrl } from '../../modules/hooks/lib/useCurrentUrl';

// Use named rather than default exports.
export const ACDLanalyticsWrapper = (props: { pageExperienceVariant?: string }) => {
  const { isACDLenabled, datalayer, updateDatalayer } = useSession();
  const [dataLayerLoaded, setDataLayerLoaded] = useState(false);
  const url = useCurrentUrl();

  useEffect(() => {
    if (!dataLayerLoaded && datalayer && !!isACDLenabled) {
      setDataLayerLoaded(true);
    }
  }, [isACDLenabled, datalayer]);

  useEffect(() => {
    if (!dataLayerLoaded) {
      return;
    }
    // fired once when datalayer is ready (first load) and whenever the URL changes
    pushPageViewEvent();
  }, [dataLayerLoaded, url]);
  function pushPageViewEvent() {
    const datalayerObj = pageViewACDLkeyGenerator({ datalayer });
    if (props.pageExperienceVariant && datalayerObj['page']) {
      datalayerObj['page'] = { ...datalayerObj['page'], experience: `Pattern ${props.pageExperienceVariant}` };
    }
    updateDatalayer({
      event: EVENT_NAME.PAGEVIEW,
      ...datalayerObj,
    });
  }
  return <></>;
};
